import * as api from '../utils/api'

import { addStore, addStores, setStoresCount } from '../store/actions/stores'
import { createSelector } from 'reselect'
import { setStoreOnline as setStoreOnlineRedux } from '../store/actions/store-online'
import { updateProductsStores } from '../store/actions/products-stores'

export const fetchStore = (id) => async (dispatch) => {
  console.log(`Fetching store with ID ${id}`)
  const { data } = await api.GET(`/p4/stores/${id}`)
  return dispatch(addStore(data))
}

export const fetchStores = () => async (dispatch) => {
  console.log('Fetching stores')
  const {
    data: { stores, total_rows },
  } = await api.GET('/p4/stores')
  return Promise.all([
    dispatch(addStores(stores)),
    dispatch(setStoresCount(total_rows)),
  ])
}

export const setStoreOnline = (storeId, online) => async (dispatch) => {
  console.log(`Setting store ${storeId} online status to ${online}`)
  const { data } = await api.POST(`/p4/stores/${storeId}/online`, { online })
  return dispatch(setStoreOnlineRedux(storeId, !data.offline))
}

export const fetchStoreOnline = (storeId) => async (dispatch) => {
  console.log(`Fetching online status for store ${storeId}`)
  const { data } = await api.GET(`/stores/${storeId}/status`)
  return dispatch(setStoreOnlineRedux(storeId, data.online))
}

export const updateStore = (storeId, storeData) => async (dispatch) => {
  console.log(`Updating store ${storeId}`)
  const { data } = await api.PATCH(`/p4/stores/${storeId}`, storeData)
  return dispatch(addStore(data))
}

export const createStore = (data) => async (dispatch) => {
  console.log(`Creating store`)
  const { data: store } = await api.POST(`/p4/stores`, data)
  await dispatch(addStore(store))
  return store
}

export const fetchProductsStoresForStoreId = (storeId) => async (dispatch) => {
  console.log(`Fetching products_stores for store ${storeId}`)
  const { data: productsStores } = await api.GET(
    `/p4/stores/${storeId}/products/atStore`,
  )
  return dispatch(updateProductsStores(productsStores, { storeId }))
}

// the overall store fetching still has to be refactored into selectors
// at that time move this to the selector file
const storesSelector = (rootState) => rootState.Stores

export const allStoresSelector = createSelector(storesSelector, (state) => {
  return state.stores
})
